import Swiper from 'swiper/bundle';

export default function initializeOffersSlider() {
  const blocks = document.querySelectorAll('.block-offers-slider__swiper');
  if (!blocks.length) return;

  blocks.forEach((el) => {
    const paginationEl = el.querySelector('.block-offers-slider__pagination');
    if (!paginationEl) return;

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      loop: false,
      grapbCursor: true,
      pagination: {
        el: paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 4,
        },
      },
    });
  });
}
